import { useTranslation } from 'react-i18next';
import styles from './MaintenanceBanner.module.css';

/**
 * The user-visible statement of the core-content read-only posture.
 *
 * Presentation only: it makes the state legible, it does not enforce
 * anything. Enforcement is the shared write guard (assertCoreWriteAllowed
 * at the store layer, assertDbWrite at the persistence layer), because a
 * banner can be scrolled past and a hidden button can be re-enabled from
 * a console, whereas a guarded write cannot land.
 *
 * `aria-live="polite"`: informational, not an error. The user has not
 * done anything wrong, and nothing they have written is at risk.
 */
export default function MaintenanceBanner() {
  const { t } = useTranslation();
  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.title}>{t('maintenance.title')}</span>
      <span className={styles.body}>{t('maintenance.body')}</span>
    </div>
  );
}
